let id = 0;
export default function historyReducer(state, action) {
  let current;
  let backList;
  let nextList;
  let tabState;
  const { itemType, itemIndex } = action;
  switch (action.type) {
    case 'next':
      tabState = state[action.activeTab];
      current = tabState.next[0];
      if (!current) { return state; }
      backList = [tabState.current].concat(tabState.back);
      nextList = tabState.next.slice(1);
      return {
        ...state,
        [action.activeTab]: {
          current: current,
          back: backList,
          next: nextList
        }
      };
    case 'back':
      tabState = state[action.activeTab];
      current = tabState.back[0];
      if (!current) { return state; }
      backList = tabState.back.slice(1);
      nextList = [tabState.current].concat(tabState.next);
      return {
        ...state,
        [action.activeTab]: {
          current: current,
          back: backList,
          next: nextList
        }
      };
    case 'select': {
      tabState = state[action.activeTab];
      current = tabState[itemType][itemIndex];
      const moveToType = itemType === 'back' ? 'next' : 'back';
      const moveItems = tabState[itemType].slice(0, itemIndex);

      return {
        ...state,
        [action.activeTab]: {
          current: current,
          [moveToType]: moveItems.concat([tabState.current], tabState[moveToType]),
          [itemType]: tabState[itemType].slice(itemIndex + 1)
        }
      };
    }
    case 'new': {
      tabState = state[action.activeTab];
      if (!tabState.current.url) {
        return {
          ...state
        };
      }

      nextList = [];
      backList = [tabState.current].concat(tabState.back);

      id += 1;

      return {
        ...state,
        [action.activeTab]: {
          current: {
            id: `new:tab${id}`,
            url: '',
            title: 'New Tab',
            bgClass: null
          },
          back: backList,
          next: nextList
        }
      };
    }
    case 'changeBackground': {
      tabState = state[action.activeTab];
      return {
        ...state,
        [action.activeTab]: {
          ...tabState,
          current: {
            ...tabState.current,
            bgClass: action.bgClass
          }
        }
      };
    }
    default:
      throw new Error('Invalid action type')
  }
}
